/* ===========================================================================
   <countdown-block> custom element
   ---------------------------------------------------------------------------
   Powers the countdown timer rendered by snippets/countdown-timer.liquid.
   Used in two places:
     1. PDP — sections/main-product.liquid (countdown_timer block)
     2. Cart drawer — sections/mini-cart.liquid (above checkout button)

   Why this lives in a global JS file instead of the snippet:
   The cart drawer is lazy-loaded via Shopify's section rendering API
   (see <mini-cart> in sections/header.liquid). cart-drawer.js inserts
   the fetched HTML via innerHTML, which means any inline <script> tags
   inside the snippet would NOT execute. Defining the custom element
   here, loaded globally with `defer`, guarantees the class is registered
   on every page — so when <countdown-block> appears in the DOM (initial
   render OR via AJAX), it auto-upgrades and the timer starts.

   The element counts down to the next local-midnight, hides the "Days"
   unit when zero, and cleans up its interval on disconnect.
   =========================================================================== */
(function () {
  if (typeof customElements === 'undefined') return;
  if (customElements.get('countdown-block')) return;

  function pad(num) { return String(num).padStart(2, '0'); }

  function getNextMidnight() {
    var target = new Date();
    target.setHours(24, 0, 0, 0);
    return target;
  }

  class CountdownBlock extends HTMLElement {
    connectedCallback() {
      this.daysEl    = this.querySelector('[data-unit="days"]');
      this.hoursEl   = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="mins"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');
      this.targetTime = getNextMidnight();
      this.tick();
      this.intervalId = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    tick() {
      var now = new Date();
      if (now >= this.targetTime) this.targetTime = getNextMidnight();

      var diffMs = this.targetTime - now;
      if (diffMs < 0) diffMs = 0;

      var totalSeconds = Math.floor(diffMs / 1000);
      var days    = Math.floor(totalSeconds / 86400);
      var hours   = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (this.daysEl) {
        var daysContainer = this.daysEl.parentElement;
        var daysSeparator = daysContainer.nextElementSibling;
        if (days === 0) {
          daysContainer.style.display = 'none';
          if (daysSeparator && daysSeparator.classList.contains('timer-separator')) {
            daysSeparator.style.display = 'none';
          }
        } else {
          daysContainer.style.display = '';
          if (daysSeparator && daysSeparator.classList.contains('timer-separator')) {
            daysSeparator.style.display = '';
          }
          this.daysEl.textContent = pad(days);
        }
      }
      if (this.hoursEl)   this.hoursEl.textContent   = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    }
  }

  customElements.define('countdown-block', CountdownBlock);
})();
